import { createSlice } from '@reduxjs/toolkit'

// utils
import axios from '../../utils/axios'

// Slice to manage API calls from contact page

const initialState = {
  isLoading: false,
  success: false,
  error: null,
  contactRequests: []
}

const slice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.error = null
      state.isLoading = true
      state.success = null
    },

    // hasError
    hasError(state, action) {
      state.isLoading = null
      state.error = action.payload
      state.success = null
    },

    // POST Message
    isSuccess(state, action) {
      state.isLoading = null
      state.success = true
    },

    getContactRequestsSuccess(state, action) {
      state.isLoading = null
      state.success = true
      state.contactRequests = action.payload
    },

    resetState(state) {
      state.isLoading = false
      state.success = null
      state.error = null
    }
  }
})

export default slice.reducer
export const { actions } = slice

export const sendContactMessage = (data) => async (dispatch) => {
  try {
    dispatch(actions.startLoading())
    const response = await axios.post('/api/v1/public/contact-request', data)
    dispatch(actions.isSuccess(response.data))
  } catch (error) {
    dispatch(actions.hasError(error))
  }
}

// Actions
export const getContactRequests = () => async (dispatch) => {
  try {
    dispatch(actions.startLoading())

    const response = await axios.get('/api/v1/public/contact-request')

    dispatch(actions.getContactRequestsSuccess(response.data))
  } catch (error) {
    dispatch(actions.hasError(error))
  }
}

export const resetContactState = () => async (dispatch) => {
  dispatch(actions.resetState())
}
